import $ from 'jquery';

var horsePeople = {
    _putCommaInCount: function(num) {
        return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },

    _setupHomeGrid: function() {
        $('.grid li').each(
            function(i, element) {
                var $this = $(element),
                    $video = $this.find('.videoName'),
                    videoID = $video.attr('id');

                $video.append('<div class="gridView"></div>');

                this._getYoutubeData(videoID, $('#' + videoID + ' .gridView'));
            }.bind(this)
        );
    },

    _addYoutubeData: function($element, $div) {
        var video = $element
                .find('iframe')
                .attr('src')
                .split('embed/'),
            videoID = video[1].split('?');

        $div.find('h1').after('<div class="view"></div><div class="descript"></div>');

        this._getYoutubeData(videoID, $('.view'));
    },

    _getYoutubeData: function(videoID, $element) {
        $.ajax({
            url:
                'https://www.googleapis.com/youtube/v3/videos?id=' +
                videoID +
                '&key=AIzaSyDRWCQm4-qSW7HOKLgxgVaqDkP6O3t_N1A&part=snippet,statistics',
            dataType: 'jsonp'
        }).done(
            function(data) {
                var $view = $('.view').get(0);

                $element.html(
                    '<strong>View Count:</strong> ' + this._putCommaInCount(data.items[0].statistics.viewCount)
                );

                if ($element.get(0) === $view) {
                    $('.descript').html(data.items[0].snippet.description);
                }
            }.bind(this)
        );
    },

    _runFacebookScript: function() {
        (function(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.5';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    },

    _init: function() {
        var $hero = $('.hero'),
            $heroTxt = $('.heroTxt'),
            $main = $('.mainVid'),
            $mainTxt = $('.mainTxt'),
            $sidebar = $('.key');

        if ($hero.length) {
            $sidebar.hide();
            this._setupHomeGrid();
            this._addYoutubeData($hero, $heroTxt);
        } else {
            this._addYoutubeData($main, $mainTxt);
        }

        this._runFacebookScript();
    }
};

export default horsePeople;